import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import React__default, { forwardRef, useRef, useState, useEffect } from 'react';
import classNames from 'classnames';
import styles from './92eaf70a5288baa390f98abe62f370ca7d0fa305958109435f118350410b09ae.cfe-internal.js';
import '../../icons/index.es.js';
import { useFormFieldControl } from '../FormField/f390dafefe74ba07f7da711a77443b7b51d96a6ad1aee47361fd1804064e9ba7.cfe-internal.js';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import { useDropdownContext } from './96f486109d0d2850b21eef94a8c44cc3323a66fb525ca5574171063673f9afca.cfe-internal.js';
import '../../hooks/8930fff059088aae845742b95b03a9c78f1349f3c58d1781f854d37c28181edd.cfe-internal.js';
import useControllableState from '../../hooks/useControllableState/fc7c2512fc1249f4837f2cb1f271d18191fa6aebd32c5f03023614c2b76711ef.cfe-internal.js';
import concatIds from '../../utils/concatIds/99a67648a55cf7a2ee84ef14be5ebb23af1b4b19b5520388cd5eef8f3f3a1e28.cfe-internal.js';
import mergeRefs from '../../utils/mergeRefs/836dcb860bec00d9c59bd64df8df6df42430840bc5bfc21b6000935baefbeacd.cfe-internal.js';
import wrapEvent from '../../utils/wrapEvent/e6437ee06b490c01a1330c8f2f370768104fbf0b8f6557d196331cda5427061b.cfe-internal.js';
import ChevronDownIcon from '../../icons/components/7c7c780956cb4e93fe69a1384927ee5fbe6526f5bb2422c9d44843841947bab7.cfe-internal.js';

var _excluded = ["children", "className", "disabled", "isInvalid", "defaultLabel", "label", "onLabelChange", "onKeyDown", "onClick", "onFocus", "onBlur", "aria-labelledby", "aria-label", "aria-describedby"];
var DropdownButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref2, _children$props$aria, _children$props, _context, _ref3, _children$props$aria2, _children$props2, _context2, _ref4, _children$props$aria3, _children$props3, _children$props$tabIn, _children$props4, _children$props7, _children$props8;
  var children = _ref.children,
    className = _ref.className,
    disabled = _ref.disabled,
    isInvalidProp = _ref.isInvalid,
    _ref$defaultLabel = _ref.defaultLabel,
    defaultLabel = _ref$defaultLabel === void 0 ? '' : _ref$defaultLabel,
    externalLabel = _ref.label,
    onLabelChange = _ref.onLabelChange,
    onKeyDown = _ref.onKeyDown,
    onClick = _ref.onClick,
    _onFocus = _ref.onFocus,
    _onBlur = _ref.onBlur,
    externalAriaLabelledBy = _ref['aria-labelledby'],
    externalAriaLabel = _ref['aria-label'],
    externalAriaDescribedBy = _ref['aria-describedby'],
    rest = _objectWithoutProperties(_ref, _excluded);
  var buttonRef = useRef(null);
  var _useDropdownContext = useDropdownContext(),
    isOpen = _useDropdownContext.isOpen,
    options = _useDropdownContext.options,
    setMinWidth = _useDropdownContext.setMinWidth,
    setIsOpen = _useDropdownContext.setIsOpen,
    dropdownAriaDisabled = _useDropdownContext.disabled,
    dropdownIsInvalid = _useDropdownContext.isInvalid,
    dropdownButtonRef = _useDropdownContext.buttonRef,
    onKeyDownButton = _useDropdownContext.onKeyDownButton,
    selectedIndex = _useDropdownContext.selectedIndex,
    setHighlightedIndex = _useDropdownContext.setHighlightedIndex,
    listId = _useDropdownContext.listId,
    buttonId = _useDropdownContext.buttonId,
    dropdownAriaLabelledBy = _useDropdownContext.ariaLabelledBy,
    dropdownAriaLabel = _useDropdownContext.ariaLabel,
    dropdownAriaDescribedby = _useDropdownContext.ariaDescribedby;
  var _useControllableState = useControllableState(defaultLabel,
    // will get updated in effect
    onLabelChange, externalLabel),
    _useControllableState2 = _slicedToArray(_useControllableState, 2),
    label = _useControllableState2[0],
    setLabel = _useControllableState2[1];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOptionSelected = _useState2[0],
    setIsOptionSelected = _useState2[1];
  var _useFormFieldControl = useFormFieldControl(),
    hasFormLabel = _useFormFieldControl.hasLabel,
    formFieldHelperTextId = _useFormFieldControl.helperTextId,
    formFieldErrorTextId = _useFormFieldControl.errorTextId;
  var ariaLabelledBy = (_ref2 = (_children$props$aria = children === null || children === void 0 || (_children$props = children.props) === null || _children$props === void 0 ? void 0 : _children$props['aria-labelledby']) !== null && _children$props$aria !== void 0 ? _children$props$aria : externalAriaLabelledBy) !== null && _ref2 !== void 0 ? _ref2 : dropdownAriaLabelledBy ? _concatInstanceProperty(_context = "".concat(dropdownAriaLabelledBy, " ")).call(_context, buttonId) : undefined;
  var ariaLabel = (_ref3 = (_children$props$aria2 = children === null || children === void 0 || (_children$props2 = children.props) === null || _children$props2 === void 0 ? void 0 : _children$props2['aria-label']) !== null && _children$props$aria2 !== void 0 ? _children$props$aria2 : externalAriaLabel) !== null && _ref3 !== void 0 ? _ref3 : dropdownAriaLabel && typeof label === 'string' ? _concatInstanceProperty(_context2 = "".concat(dropdownAriaLabel, " ")).call(_context2, label) : dropdownAriaLabel;
  var ariaDescribedby = concatIds((_ref4 = (_children$props$aria3 = children === null || children === void 0 || (_children$props3 = children.props) === null || _children$props3 === void 0 ? void 0 : _children$props3['aria-describedby']) !== null && _children$props$aria3 !== void 0 ? _children$props$aria3 : externalAriaDescribedBy) !== null && _ref4 !== void 0 ? _ref4 : dropdownAriaDescribedby, formFieldHelperTextId, formFieldErrorTextId);
  useEffect(function () {
    var selectedLabels = [];
    _forEachInstanceProperty(options).call(options, function (option) {
      if (option.isSelected) {
        selectedLabels.push(option.label);
      }
    });
    setIsOptionSelected(selectedLabels.length > 0);
    setLabel(selectedLabels.length > 0 ? selectedLabels.join(', ') : defaultLabel);
  }, [setLabel, options, defaultLabel]);
  useEffect(function () {
    var _buttonRef$current;
    setMinWidth(buttonRef === null || buttonRef === void 0 || (_buttonRef$current = buttonRef.current) === null || _buttonRef$current === void 0 ? void 0 : _buttonRef$current.offsetWidth);
  });
  var isInvalid = isInvalidProp !== undefined ? isInvalidProp : dropdownIsInvalid;
  var handleClick = function handleClick(e) {
    if (disabled !== null && disabled !== void 0 ? disabled : dropdownAriaDisabled) return;
    onClick === null || onClick === void 0 || onClick(e);
    // Needed because some browsers don't focus on click
    e.currentTarget.focus();
    setIsOpen(function (currentIsOpen) {
      setHighlightedIndex(currentIsOpen ? -1 : selectedIndex);
      return !currentIsOpen;
    });
  };
  var handleKeyDown = function handleKeyDown(e) {
    if (disabled !== null && disabled !== void 0 ? disabled : dropdownAriaDisabled) return;
    onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
    onKeyDownButton(e);
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, children ? ( /*#__PURE__*/React__default.cloneElement(children, {
    ref: mergeRefs(ref, children === null || children === void 0 ? void 0 : children.ref, buttonRef, dropdownButtonRef),
    disabled: disabled || dropdownAriaDisabled,
    'aria-disabled': dropdownAriaDisabled,
    tabIndex: (_children$props$tabIn = (_children$props4 = children.props) === null || _children$props4 === void 0 ? void 0 : _children$props4.tabIndex) !== null && _children$props$tabIn !== void 0 ? _children$props$tabIn : 0,
    role: 'button',
    'aria-expanded': isOpen,
    'aria-haspopup': 'listbox',
    'aria-controls': listId,
    'aria-labelledby': ariaLabelledBy,
    'aria-label': ariaLabel,
    'aria-describedby': ariaDescribedby,
    id: buttonId,
    onFocus: function onFocus(e) {
      var _children$props5, _children$props5$onFo;
      (_children$props5 = children.props) === null || _children$props5 === void 0 || (_children$props5$onFo = _children$props5.onFocus) === null || _children$props5$onFo === void 0 || _children$props5$onFo.call(_children$props5, e);
      _onFocus === null || _onFocus === void 0 || _onFocus(e);
    },
    onBlur: function onBlur(e) {
      var _children$props6, _children$props6$onBl;
      (_children$props6 = children.props) === null || _children$props6 === void 0 || (_children$props6$onBl = _children$props6.onBlur) === null || _children$props6$onBl === void 0 || _children$props6$onBl.call(_children$props6, e);
      _onBlur === null || _onBlur === void 0 || _onBlur(e);
    },
    onKeyDown: wrapEvent((_children$props7 = children.props) === null || _children$props7 === void 0 ? void 0 : _children$props7.onKeyDown, handleKeyDown),
    onClick: wrapEvent((_children$props8 = children.props) === null || _children$props8 === void 0 ? void 0 : _children$props8.onClick, handleClick)
  })) : /*#__PURE__*/React__default.createElement("button", _extends({}, rest, {
    ref: mergeRefs(ref, buttonRef, dropdownButtonRef),
    type: "button",
    disabled: disabled || dropdownAriaDisabled,
    "aria-disabled": dropdownAriaDisabled,
    "aria-expanded": isOpen,
    "aria-haspopup": "listbox",
    "aria-controls": listId,
    "aria-labelledby": ariaLabelledBy,
    "aria-label": ariaLabel,
    "aria-describedby": ariaDescribedby,
    id: buttonId,
    className: classNames(className, styles.button, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles.hasText, !!label), styles.invalid, isInvalid), styles.labelled, hasFormLabel), styles.selected, externalLabel !== null && externalLabel !== void 0 ? externalLabel : isOptionSelected)),
    onFocus: _onFocus,
    onBlur: _onBlur,
    onKeyDown: handleKeyDown,
    onClick: handleClick
  }), /*#__PURE__*/React__default.createElement("span", {
    className: classNames(styles.buttonLabel, _defineProperty({}, styles.isString, typeof label === 'string'))
  }, label), /*#__PURE__*/React__default.createElement(ChevronDownIcon, {
    size: "medium",
    className: classNames(styles.icon, _defineProperty(_defineProperty({}, styles.open, isOpen), styles.disabled, disabled !== null && disabled !== void 0 ? disabled : dropdownAriaDisabled)),
    "aria-hidden": "true"
  })));
});
var DropdownButton$1 = DropdownButton;

export { DropdownButton$1 as default };
